import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ProjectService } from '../../../services/project.service';
import { ReportJobsService } from '../../../services/report-jobs.service';
import { ReportHubService } from '../../../services/report-hub.service';
import { ToastService } from '../../../services/toast.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-project-budget-execution-reports',
  templateUrl: './project-budget-execution-reports.component.html',
  styleUrls: ['./project-budget-execution-reports.component.scss']
})
export class ProjectBudgetExecutionReportsComponent implements OnInit, OnDestroy {
  selectedProjectId: number | null = null;
  projects: any[] = [];
  loading = false;

  // Dropdown options for PrimeNG
  projectsDropdown: any[] = [];

  private reportHubSub!: Subscription;
  private pendingJobId: string | null = null;

  constructor(
    private http: HttpClient,
    private projectService: ProjectService,
    private reportJobsService: ReportJobsService,
    private reportHubService: ReportHubService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.loadProjects();

    this.reportHubSub = this.reportHubService.reportStatusChanged$.subscribe(notification => {
      if (notification.jobId !== this.pendingJobId) return;

      if (notification.status === 'Completed') {
        this.loading = false;
        this.toastService.showToast('success', 'Reporte de ejecución presupuestal generado exitosamente. Descargando...');
        this.reportJobsService.downloadReport(notification.jobId, notification.fileName || undefined);
        this.pendingJobId = null;
      } else if (notification.status === 'Failed') {
        this.loading = false;
        this.toastService.showToast('error', `Error al generar el reporte: ${notification.errorMessage || 'Desconocido'}`);
        this.pendingJobId = null;
      } else if (notification.status === 'Processing') {
        this.toastService.showToast('info', 'Procesando reporte de ejecución presupuestal...');
      }
    });
  }

  ngOnDestroy(): void {
    this.reportHubSub?.unsubscribe();
  }

  loadProjects(): void {
    this.http.get(`${environment.apiUrl}/ProjectBudgetExecutionReports/projects`).subscribe({
      next: (response: any) => {
        if (response && response.data) {
          this.projects = response.data;
        } else if (Array.isArray(response)) {
          this.projects = response;
        }

        // Initialize projects dropdown
        this.projectsDropdown = this.projects.map(project => ({
          label: `${project.projectId} - ${project.name}`,
          value: project.id
        }));
      },
      error: (error) => {
        console.error('Error loading projects:', error);
        this.projects = [];
        this.projectsDropdown = [];
      }
    });
  }

  downloadExcelReport(): void {
    if (!this.selectedProjectId) {
      this.toastService.showToast('warning', 'Por favor seleccione un proyecto');
      return;
    }

    this.loading = true;
    this.reportJobsService.queueBudgetExecutionReport(this.selectedProjectId).subscribe({
      next: (response) => {
        this.pendingJobId = response.jobId;
        this.toastService.showToast('info', 'Generando reporte de ejecución presupuestal en segundo plano...');
      },
      error: (error) => {
        console.error('Error requesting report:', error);
        this.loading = false;
        this.toastService.showToast('error', 'Error al solicitar el reporte. Por favor intente nuevamente.');
      }
    });
  }

  get selectedProjectName(): string {
    if (!this.selectedProjectId) return 'Sin seleccionar';
    const project = this.projects.find(p => p.id === this.selectedProjectId);
    return project ? `${project.projectId} - ${project.name}` : 'Sin seleccionar';
  }

  get isFormValid(): boolean {
    return !!this.selectedProjectId;
  }
}
